(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-analysis/assets/route-play-analysis.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-analysis/assets/route-play-analysis.js');
"use strict";

const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  useFetchAnalysesByDraw
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const {
  selectDrawAnalysesShouldShowSkeleton
} = svs.components.sportinfo.gameAnalysesRedux.selectors;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useContext
} = React;
const {
  SideNavResize
} = svs.components.tipsen.sideNavResize;
const {
  Analyze
} = svs.components.sportinfo.analyze;
const {
  setCouponValues
} = svs.components.tipsen.engine.actions;
const {
  useCouponId
} = svs.components.tipsen.couponId;
const {
  selectOutcomesEventTypeId
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const RoutePlayAnalysis = _ref => {
  let {
    branding,
    className
  } = _ref;
  const {
    productId,
    drawNumber
  } = useContext(DrawContext);
  useFetchAnalysesByDraw(drawNumber, productId);
  const shouldShowSkeleton = useSelector(state => selectDrawAnalysesShouldShowSkeleton(state, productId, drawNumber));
  const dispatch = useDispatch();
  const couponId = useCouponId();
  const eventTypeId = useSelector(selectOutcomesEventTypeId);
  const draw = useCurrentDraw();
  const sportType = draw.sportType;
  if (shouldShowSkeleton) {
    return 'Hämtar spelanalyser...';
  }
  const setCoupon = signs => {
    dispatch(setCouponValues({
      couponId,
      signs: [{
        signs
      }]
    }));
  };
  return React.createElement(ErrorBoundary, null, React.createElement(SideNavResize, null, React.createElement("div", {
    className: className
  }, React.createElement(Analyze, {
    branding: branding,
    drawNumber: drawNumber,
    eventTypeId: eventTypeId,
    productId: productId,
    setCoupon: setCoupon,
    sportType: sportType
  }))));
};
setGlobal('svs.components.tipsen.routePlayAnalysis.RoutePlayAnalysis', RoutePlayAnalysis);

 })(window);